var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../I18N";
import { Button, Modal } from '.';






const ConfirmNavigationModal = ({
  setShowModal,
  onConfirm = () => undefined
}) => /*#__PURE__*/
_jsx(Modal, { size: "md" }, void 0, /*#__PURE__*/
_jsx(Modal.Header, {}, void 0, /*#__PURE__*/
_jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Discard changes?")
), /*#__PURE__*/
_jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
), /*#__PURE__*/
_jsx(Modal.Body, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "You have unsaved changes. Do you want to continue?")
), /*#__PURE__*/
_jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
_jsx(Button, { styling: "light", onClick: () => setShowModal(false), className: "grow" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Cancel")
), /*#__PURE__*/
_jsx(Button, {
  onClick: () => {
    setShowModal(false);
    onConfirm();
  },
  className: "grow" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Discard changes")
)
)
);


export { ConfirmNavigationModal };